import { MSAL_INSTANCE } from "../api/api-config";
import { ORGANIZATION_ID_SESSION_STORAGE_KEY } from "../components/organization-details-context";

export const getAuthorizationHeader = async () => {
  const account = MSAL_INSTANCE.getAllAccounts()[0];
  const accessToken = account
    ? (
        await MSAL_INSTANCE.acquireTokenSilent({
          scopes: ["api://samis/access_as_user"],
          account,
        })
      ).accessToken
    : "";
  return `Bearer ${accessToken}`;
};

export const getOrganizationId = () => {
  const organizationId = sessionStorage.getItem(
    ORGANIZATION_ID_SESSION_STORAGE_KEY,
  );

  if (!organizationId) {
    throw new Error("Organization ID not found");
  }

  return organizationId;
};
